const createSelectOption = (numberOfBoxes, lensesPerBox, getLabel) => {
  const label = `${lensesPerBox * numberOfBoxes} ${getLabel("products.unit.contactLenses", {
    defaultValue: "lenses"
  })}`;
  return `${numberOfBoxes} (${label})`;
};
const createOptionsList = ({
  maxSelectableQuantity,
  lensesPerBox,
  getLabel
}) => {
  return Array(maxSelectableQuantity).fill(0).reduce((options, _, index) => {
    const numberOfBoxes = index + 1;
    const name = createSelectOption(numberOfBoxes, lensesPerBox, getLabel);
    options[name] = numberOfBoxes;
    return options;
  }, {});
};
export {
  createOptionsList
};
//# sourceMappingURL=create-options-list.js.map
